<template>
  <form>
    <div class="row">
      <div style="width: 50%;" class="pl-2 pr-2">
        <div class="form-group">
          <label for="prodpicture" class="form-label">Product Picture:</label>
          (Enlarged pic name = *_lg.jpg)
          <input
            type="text"
            class="form-control"
            name="prodpicture"
            v-model="product.productsParent.imageurl"
          />
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Product Name:</label>
          <input
            type="text"
            class="form-control"
            name="prodname"
            v-model="product.productsParent.name"
          />
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Category:</label>
          <select
            class="form-control"
            @change="getCategoryOne($event)"
            v-model="product.productsParent.HID1"
          >
            <!-- <option value="">--Select--</option> -->
            <option
              v-for="category in allCategory"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Subcategory 1:</label>
          <select
            class="form-control"
            @change="getCategoryTwo($event)"
            v-model="product.productsParent.HID2"
          >
            <!-- <option value="">--Select--</option> -->

            <option
              v-for="category in allCategoryOne"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Subcategory 2:</label>
          <select class="form-control" v-model="product.productsParent.HID3">
            <!-- <option value="">--Select--</option> -->
            <option
              v-for="category in allCategoryTwo"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="proddesc" class="form-label">Product Description:</label>
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="13"
            v-model="product.productsParent.description"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="manufacturer" class="form-label">Manufacturer:</label>
          <input
            type="text"
            class="form-control"
            name="manufacturer"
            v-model="product.productsParent.manufacturername"
          />
        </div>

        <div class="form-group">
          <label for="brand" class="form-label">Brand:</label>
          <input
            type="text"
            class="form-control"
            name="brand"
            v-model="product.productsParent.brand"
          />
        </div>

        <div class="form-group">
          <label for="brandKey" class="form-label">Tango Brand Key:</label>
          <input
            type="text"
            class="form-control"
            name="brandKey"
            v-model="product.productsParent.brandKey"
          />
        </div>

        <div class="form-group">
          <label for="supplier" class="form-label">Supplier:</label>
          <select
            class="form-control"
            aria-label="Default select example"
            v-model="product.productsParent.supplierid"
          >
            <option
              v-for="supplier in this.allSuppliers.Result"
              :key="supplier.id"
              :value="supplier.id"
            >
              {{ supplier.name }}
            </option>
          </select>
        </div>
      </div>
      <div style="width: 50%;" class="pl-2 pr-2">
        <div class="form-group">
          <label class="form-check-label" for="flexSwitchCheckDefault"
            >What's hot product:</label
          >
          <div class="form-switch mt-1">
            <b-form-checkbox
              v-model="product.productsParent.whatshot"
              :true-value="true"
              :false-value="false"
              switch
            />
          </div>
        </div>

        <div
          class="form-group mt-4"
          id="whatsHotInfo"
          v-if="product.productsParent.whatshot"
        >
          <label for="whList">Display this what's hot item to:</label>
          <select
            v-model="product.productsParent.whatsHotClientIDs"
            id="whList"
            name="whList"
            size="20"
            class="form-control"
            :multiple="true"
            :close-on-select="false"
          >
            <option
              v-for="client in allClients"
              :key="client.id"
              :value="client.id"
            >
              {{ client.name }}
            </option>
          </select>

          <br />
          <div>
            <div class="btn-grp">
              <input
                class="btn btn-primary btn-sm"
                value="Select All"
                @click="selectAll"
              />
            </div>
            <div class="btn-grp" style="margin-left: 10px">
              <input
                class="btn btn-primary btn-sm"
                value="Deselect All"
                @click="deSelectAll"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="mt-3 table-responsive">
      <table class="table border table-sm table-striped table-responsive">
        <thead>
          <tr>
            <th scope="col">Supplier SKU</th>
            <th scope="col">Wholesale cost</th>
            <th scope="col">Shipping cost</th>

            <!-- Conditionally show fields -->
            <th v-if="product.productsParent.supplierid != 316" scope="col">Color</th>
            <th scope="col">Size</th>
            <th v-if="product.productsParent.supplierid != 316" scope="col">Location</th>
            <th v-if="product.productsParent.supplierid != 316" scope="col">Cover</th>

            <th scope="col">Deleted</th>
            <th scope="col"></th>
          </tr>
        </thead>

        <tbody id="productChildren">
          <tr v-for="(content, index) in product.productsChildren" :key="index">
            <input
              type="hidden"
              class="productChildID form-control input-sm"
              name="ProductChildID|1"
              value="0"
              v-model="content.productchildid"
            />
            <td>
              <input
                v-model="content.distributersku"
                type="text"
                class="productChildSupplierSKU form-control input-sm"
                name="ProductChildSupplierSKU|1"
              />
            </td>
            <td>
              <input
                type="number"
                class="productChildPrice form-control input-sm"
                name="ProductChildPrice|1"
                placeholder="0.00"
                v-model.number="content.price"
              />
            </td>
            <td>
              <input
                type="number"
                class="productChildShippingPrice form-control input-sm"
                name="ProductChildShippingPrice|1"
                placeholder="0.00"
                v-model.number="content.shippingcost"
              />
            </td>

            <!-- Conditionally render color/size/location/cover -->
            <!-- Color -->
            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildColor|1"
                class="form-control input-sm"
                :value="getSpecValue(content, 'Color')"
                @input="updateSpecValue(content, 'Color', $event.target.value)"
              />
            </td>

            <!-- Size -->
            <td>
              <input
                type="text"
                name="ProductChildSize|1"
                class="form-control input-sm"
                :value="getSpecValue(content, 'Size')"
                @input="updateSpecValue(content, 'Size', $event.target.value)"
              />
            </td>

            <!-- Location -->
            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildLocation|1"
                class="form-control input-sm"
                :value="getSpecValue(content, 'Location')"
                @input="updateSpecValue(content, 'Location', $event.target.value)"
              />
            </td>

            <!-- Cover -->
            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildCover|1"
                class="form-control input-sm"
                :value="getSpecValue(content, 'Cover')"
                @input="updateSpecValue(content, 'Cover', $event.target.value)"
              />
            </td>

            <td>
              <div class="form-check form-switch ml-1">
                <b-form-checkbox
                  class="form-check-input"
                  v-model="content.deleted"
                  switch
                />
              </div>
            </td>
            <td>
              <input
                type="button"
                value="Add additional"
                id="btnAddAdditionalProductChildren"
                class="btn btn-primary btn-sm"
                @click="addTableRow()"
                v-show="index === product.productsChildren.length - 1"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col">
        <input
          type="button"
          class="btn btn-primary"
          value="Update Product"
          @click="onUpdate"
        />
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: "EditProductDetails",
  data() {
    return {
      allClients: [],
      // product: {
      //   productsParent: {
      //     brand: "Best Buy",
      //     name: "Test Product 101",
      //     description: "Test Product 101",
      //     featuredescription: "Test Product 101",
      //     manufacturername: "Test Product 101",
      //     imageurl: "Test Product 101",
      //     deleted: false,
      //     whatshot: false,
      //     exclude: false,
      //     supplierid: null,
      //     searsproductparentnumber: "Test Product 101",
      //     addedbyadminuserid: 736175,
      //   },
      //   productsChildren: [
      //     {
      //       price: 300.0,
      //       available: 1,
      //       weight: 10,
      //       shippingcost: 30,
      //       deleted: false,
      //       distributersku: "P10",
      //       addedbyadminuserid: 736175,
      //     },
      //   ],
      // },

      // tableRows: [
      //   {
      //     SupplierSKU: "",
      //     WholesaleCost: "",
      //     ShippingCost: "",
      //     Color: "",
      //     Size: "",
      //     Location: "",
      //     Cover: "",
      //   },
      // ],
      counter: 1,
      // isVisible: true,
      // selected: [],
    };
  },
  methods: {
    getSpecValue(content, key) {
      console.log(".................................")
      console.log(content)
      console.log(key)
      if (
        content &&
        Array.isArray(content.productChildSpecifications)
      ) {
        console.log("yyyyyyyyyyyyyyyyyy")
        const spec = content.productChildSpecifications.find(
          (s) => s.specKey === key
        );
        console.log("============================")
        console.log(spec)
        console.log(spec.specValue)
        return spec ? spec.specValue : "";
      }
      return "";
    },

    updateSpecValue(content, key, value) {

      console.log("***************")
      console.log(content)
      console.log(key)
      console.log(value)
      if (
        content &&
        Array.isArray(content.productChildSpecifications)
      ) {
        const spec = content.productChildSpecifications.find(
          (s) => s.specKey === key
        );
        if (spec) {
          spec.specValue = value;
        } else {
          console.warn(`No matching specKey found for ${key}`);
        }
      }
    },
    onUpdate(e) {
      e.preventDefault();
      // console.log(this.product.productsParent.productid);
      // update state
      this.product.productsParent.datemodified = new Date().toISOString();
      this.product.productsParent.modifiedbyadminuserid = this.userID;
      let productsChildren = this.product.productsChildren;
      // console.log(this.userID);
      for (let child of productsChildren) {
        child.datemodified = new Date().toISOString();
        child.modifiedbyadminuserid = this.userID;
      }
      console.log(productsChildren);

      // call update api
      this.$store
        .dispatch("manageProducts/updateProduct", this.product)
        .then(() => {
          // this.$store.dispatch("manageProducts/fetchProductById", {
          //   productId: this.$route.params.Id,
          // });
          this.$router.push({
            name: "ManageProducts",
          });
        });
    },
    //select all options in the select
    selectAll() {
      this.product.productsParent.whatsHotClientIDs = this.allClients.map(
        (client) => client.id
      );
    },
    //deselect all options in the select
    deSelectAll() {
      this.product.productsParent.whatsHotClientIDs = [];
    },
    //add a new row to the table
    addTableRow() {
      const date = new Date().toISOString();
      console.log(date);

      this.counter++;
      // this.product.children.push("Table Row" + this.counter);
      //add a new row to the table rows array
      this.product.productsChildren.push({
        productchildid: null,
        // productid: 5059904,
        price: null,
        // available: 1,
        weight: null,
        shippingcost: null,
        deleted: false,
        distributersku: "",
        dateadded: date,
        addedbyadminuserid: 736175,
        // datemodified: "2022-04-09T00:00:00Z",
        // modifiedbyadminuserid: null,
      });
    },
    getCategoryOne(e) {
      console.log(e.target.value);
      this.$store.commit("divvyCategory/SET_CATEGORIES_ONE", []);
      this.$store.commit("divvyCategory/SET_CATEGORIES_TWO", []);
      this.$store
        .dispatch("divvyCategory/fetchSubCategoriesOne", {
          categoryID: e.target.value,
        })
        .then((data) => {
          console.log(data);
          this.product.productsParent.categoryID = data.categoryID;
          this.product.productsParent.categoryHID = data.hid;
        });
    },
    getCategoryTwo(e) {
      console.log(e.target.value);
      this.$store.dispatch("divvyCategory/fetchSubCategoriesTwo", {
        categoryID: e.target.value,
      });
    },
  },
  computed: {
    userID() {
      return this.$store.state.user.profile.id;
    },
    product() {
      return this.$store.state.manageProducts.product;
    },
    allSuppliers() {
      return this.$store.getters["manageSuppliers/allSuppliers"];
    },
    allCategory() {
      return this.$store.getters["divvyCategory/allCategories"];
    },
    allCategoryOne() {
      return this.$store.getters["divvyCategory/allCategoriesOne"];
    },
    allCategoryTwo() {
      return this.$store.getters["divvyCategory/allCategoriesTwo"];
    },
  },
  mounted() {
    this.$store
      .dispatch("manageProducts/fetchProductById", {
        productId: this.$route.params.Id,
      })
      .then(() => {
        this.$store.dispatch("divvyCategory/fetchCategories", {
          categoryID: "/",
        });
        this.$store.dispatch("divvyCategory/fetchSubCategoriesOne", {
          categoryID: this.product.productsParent.HID1,
        });
        this.$store.dispatch("divvyCategory/fetchSubCategoriesTwo", {
          categoryID: this.product.productsParent.HID2,
        });
      });

    this.$store.dispatch("manageSuppliers/fetchAllSuppliers", {
      searchTerm: "",
      pageNumber: 1,
      pageSize: -1,
      sortField: "[NAME]",
      sortOrder: "ASC",
    });

    this.$store.dispatch("manageClients/getClients").then((clients) => {
      this.allClients = clients;
    });
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.btn-grp {
  display: inline-block;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-spacing: 0;
  border-collapse: collapse;
}

.table-bordered {
  border: 1px solid #ddd;
}

.small {
  font-size: 85%;
}

.table > thead > tr > th {
  background: #ddd;
}

.table > :not(:first-child) {
  border-top: 0px;
}

.table > tbody {
  vertical-align: inherit;
}
</style>
